import { FontSelect } from './styles'

export default FontSelect
